import React from "react";
import PropTypes from "prop-types";
import MsxIcons from "../../Icons/MsxIcons/MsxIcons";

const Button = ({
  border,
  textColor,
  large,
  bg,
  disabled,
  disabledStyle,
  classes,
  primary,
  secondary,
  error,
  loading,
  onClick,
  ...props
}) => (
  <button
    type="button"
    className={`flex items-center text-center space-x-2 py-2 md:p-2 text-xs transition-all duration-200 font-semibold
        ${border ? "border-[1px]" : ""}
        ${border === "blue" ? "border-secondary bg-white" : ""}
        ${border === "darkBlue" ? "border-darkSkyBlue bg-white" : ""}
        ${border === "yellow" ? "border-yellow-600 bg-white" : ""}
        ${border === "red" ? "border-red-600 bg-white" : ""}
        ${border === "green" ? "border-darkGreen bg-white" : ""}
        ${border === "gray" ? "border-gray-400 hover:border-gray-500" : ""}
        ${bg === "blue" ? "bg-secondary text-white hover:bg-hoverSecondary" : bg}
        ${textColor === "blue" ? "text-secondary hover:bg-secondary hover:text-white" : ""}
        ${textColor === "darkBlue" ? "text-darkSkyBlue hover:bg-darkSkyBlue hover:text-white" : ""}
        ${textColor === "yellow" ? "text-yellow-600 hover:bg-yellow-600 hover:text-white" : ""}
        ${textColor === "red" ? "text-red-600 hover:bg-red-600 hover:text-white" : ""}
        ${textColor === "green" ? "text-darkGreen hover:bg-darkGreen hover:text-white" : ""}
        ${textColor === "gray" ? "text-gray-400 hover:text-gray-500" : ""}
        ${large ? "px-8 md:px-8" : ""}
        ${(disabled || disabledStyle) && "opacity-50 cursor-not-allowed"}
        ${primary && "bg-secondary text-secondaryTextColor hover:bg-hoverSecondary hover:text-secondaryHoverTextColor"}
        ${
          secondary &&
          "border-[1px] border-solid text-secondary border-secondary hover:bg-hoverSecondary hover:text-secondaryHoverTextColor"
        }
        ${error && "border-[1px] border-solid border-red-200 bg-red-100 text-red-500"}
        ${classes}
    `}
    onClick={!disabled ? onClick : undefined}
    {...props}
  >
    {props.children}
    {error && <MsxIcons name="alert" size="nano" className="ml-1" />}
    {loading && <MsxIcons name="spinner" size="nano" className="ml-1 animate-spin" />}
  </button>
);

Button.propTypes = {
  border: PropTypes.string,
  bg: PropTypes.string,
  children: PropTypes.node,
  large: PropTypes.bool,
  textColor: PropTypes.string,
  disabled: PropTypes.bool,
  disabledStyle: PropTypes.bool,
  classes: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func
};

Button.defaultProps = {
  border: null,
  bg: null,
  children: null,
  large: false,
  textColor: null,
  disabled: false,
  disabledStyle: false,
  classes: "",
  primary: false,
  secondary: false,
  error: false,
  loading: false,
  onClick: undefined
};

export default Button;
